export default __webpack_public_path__ + "static/media/afa206d26dbbac4ffc755a4962286a1c1598738831718.1fbefda2.webp";